import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import i18n from '@nextroll/ar-i18n';

import { changeEmailFactory } from '../../../actions/email-verification/EmailVerificationActions';
import { SignUpModes } from '../../../constants';
import EmailVerificationContext from '../../../contexts/email-verification/EmailVerificationContext';
import PageBanner from '../PageBanner';

const ExpiredView = () => {
    const { state, dispatch } = useContext(EmailVerificationContext);
    const navigate = useNavigate();
    const navigateToChangeEmail = () => navigate('../change-email');

    const email = state.get('evStatus').email;
    const mode = state.get('mode');

    const resend = changeEmailFactory(dispatch, email);

    const topText = i18n.gettext('Email verification link expired');
    const bottomText = i18n.gettext(
        'Looks like the verification link has expired. Not to worry, we can send the link again.'
    );
    const error = true;

    return (
        <div className='eh-ev-form-view-expired'>
            <PageBanner
                error={error}
                topText={topText}
                bottomText={bottomText}
            />
            <div className='eh-ev-bottom-text'>
                {mode === SignUpModes.SHOPIFY &&
                    i18n.gettext(
                        'If you did not receive an email, please check your spam folder or <Link>click here</Link> to resend the verification email.',
                        {
                            Link: <a onClick={resend} />,
                        }
                    )}
                {mode !== SignUpModes.SHOPIFY &&
                    i18n.gettext(
                        '<Link>Click here</Link> if you did not receive an email or would like to change the email address you signed up with.',
                        {
                            Link: <a onClick={navigateToChangeEmail} />,
                        }
                    )}
            </div>
        </div>
    );
};

export default ExpiredView;
